import { AxiosError, AxiosResponse } from 'axios';
import { ApiClientInterceptors } from '@crypto-trading/common/browser';

/**
 * Create interceptors for JWT token refresh on 401 errors
 */
export const createTokenRefreshInterceptors = (
  refreshToken: () => Promise<void>,
): ApiClientInterceptors => {
  return {
    onResponseError: async (error: AxiosError): Promise<AxiosResponse> => {
      const originalRequest = error.config;

      // If error is 401 and we haven't tried refreshing yet
      if (error.response?.status === 401 && originalRequest) {
        console.log('[TokenRefresh] 401 detected, refreshing token...');
        
        try {
          await refreshToken();
          
          // Retry the original request with new token
          const newToken = localStorage.getItem('auth_token');
          if (newToken && originalRequest.headers) {
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          }
          
          console.log('[TokenRefresh] Token refreshed, retrying request...');
          
          // Import axios here to avoid circular dependency
          const axios = (await import('axios')).default;
          return axios(originalRequest);
        } catch (refreshError) {
          console.error('[TokenRefresh] Failed to refresh token:', refreshError);
          const errorToReject = refreshError instanceof Error 
            ? refreshError 
            : new Error('Token refresh failed');
          return Promise.reject(errorToReject);
        } finally {
        }
      }

      // If not a 401 or already refreshing, reject normally
      return Promise.reject(error);
    },
  };
};

